import SectionHeader from "./SectionHeader";

const personas = [
  {
    tag: "核心主角",
    tagCls: "bg-primary-600 text-background-50",
    name: "「幕布」账号运营者",
    img: "https://readdy.ai/api/search-image?query=editorial%20mystery%20portrait%20of%20a%20silhouetted%20figure%20holding%20a%20phone%2C%20face%20obscured%20by%20shadow%20and%20paper%20mask%2C%20warm%20amber%20and%20crimson%20lighting%2C%20documentary%20newsroom%20backdrop%2C%20muted%20background%2C%20cinematic%20depth%2C%20high%20detail&width=500&height=380&seq=fanca-persona-1-2026-a1&orientation=landscape",
    title: "反差黑料主角是谁",
    text: "被反复指认的核心对象，正面输出「理性科普」人设，私下被扒出同步运营多个意见相反的账号，评论口径与行动自相矛盾，成为反差黑料争议的起点。",
    meta: ["3 个疑点", "12 条线索", "身份未实锤"],
  },
  {
    tag: "当事人 A",
    tagCls: "bg-accent-600 text-background-50",
    name: "前合作方「L」",
    img: "https://readdy.ai/api/search-image?query=blurred%20anonymous%20business%20partner%20silhouette%20reviewing%20contract%20documents%20at%20desk%2C%20identity%20hidden%2C%20warm%20editorial%20tonal%20lighting%20amber%20and%20deep%20red%20accents%2C%20investigative%20documentary%20style%2C%20soft%20background%2C%20high%20detail&width=500&height=380&seq=fanca-persona-2-2026-a1&orientation=landscape",
    title: "第一时间发声的人",
    text: "最早抛出聊天记录与分工细节，指认「幕布」对外独占成绩。其口径在关键时间点上与另一方说法存在出入，真假仍需时间线核验。",
    meta: ["回应 2 次", "证据 6 份", "口径有出入"],
  },
  {
    tag: "当事人 B",
    tagCls: "bg-secondary-700 text-background-50",
    name: "关联账号「对照相」",
    img: "https://readdy.ai/api/search-image?query=close%20up%20of%20two%20overlapping%20phone%20screens%20showing%20mirrored%20social%20posts%2C%20anonymous%20identity%20theme%2C%20warm%20amber%20crimson%20editorial%20lighting%2C%20documentary%20investigation%20feel%2C%20soft%20neutral%20background%2C%20high%20detail&width=500&height=380&seq=fanca-persona-3-2026-a1&orientation=landscape",
    title: "被卷入关系网的另一端",
    text: "常被与「幕布」并列讨论，被指为同一账号矩阵的一环。本人曾简短回应称「账号归属与爆料方判断不符」，未提供进一步材料，仍是当前最大未解身份线。",
    meta: ["澄清 1 次", "身份归属未定", "关系存疑"],
  },
];

export default function Personas() {
  return (
    <section id="personas" className="bg-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <SectionHeader
          kicker="PART 01 · 人物画像"
          title="先搞清楚：反差黑料主角与当事人是谁"
          desc="围绕同一争议被反复点名的主角与当事人。以下仅梳理公开渠道中出现过的身份代称与各自立场，便于你先建立人物坐标，再做交叉判断。"
        />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {personas.map((p) => (
            <article
              key={p.name}
              className="rounded-xl overflow-hidden border border-background-200 bg-background-100/60 hover:shadow-sm transition-shadow flex flex-col"
            >
              <div className="relative">
                <div className="h-40 md:h-44 w-full bg-cover bg-top" style={{ backgroundImage: `url('${p.img}')` }} />
                <span className={`absolute top-3 left-3 rounded-full px-3 py-1 text-xs font-medium ${p.tagCls}`}>
                  {p.tag}
                </span>
              </div>
              <div className="p-4 md:p-5 flex flex-col flex-1">
                <h3 className="text-base md:text-lg font-semibold text-foreground-950 font-heading">
                  {p.title}
                </h3>
                <p className="mt-1 text-xs font-medium text-primary-600">{p.name}</p>
                <p className="mt-3 text-sm leading-6 text-foreground-600 flex-1">{p.text}</p>
                <div className="mt-4 flex flex-wrap gap-2">
                  {p.meta.map((m) => (
                    <span key={m} className="inline-flex items-center rounded-full bg-background-50 border border-background-200 px-2.5 py-1 text-xs text-foreground-700">
                      {m}
                    </span>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}